<template>
<div class="filters">
  <h3 class="filter-list-heading">{{title}}:</h3>
  <ul v-if="items" class="filter-list filter-filter-list">
    <li :key="item.id" v-for="item in items">
      <FilterButton
        :isActive="inFilters(item.id)"
        @clicked="updateFilters({value: item.id, field})"
      >{{capitalize(item.name)}}</FilterButton>
    </li>
  </ul>
</div>
</template>

<script>
import { capitalize } from '../../utils/helpers';
import FilterButton from '../FilterButton/FilterButton';

export default {
  name: 'FilterList',
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  components: {
    FilterButton
  },
  methods: {
    capitalize,
    inFilters(value) {
      if (this.filters.find(o => o === value)) {
          return true
      }
    },
    updateFilters({ field, value }) {
      let newFilters = [...this.filters];
      if (newFilters.includes(value)) {
        newFilters = newFilters.filter(o => o !== value);
      } else {
        newFilters.push(value);
      }

      this.$emit('updated', { name: field, filters: newFilters });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.filters {
  margin: 20px 0;
  // background-color: #fff;
  padding: 10px 20px;
  border-radius: 3px;
}

.filter-list-heading {
  font-size: 16px;
  font-weight: bold;
  color: $accent-color;
  padding: 5px 0;
  border-bottom: 1px solid $accent-color;
  margin-bottom: 10px;
}

.filter-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.filter-list li {
  padding: 10px 5px;
  min-width: 150px;
}
</style>
